import { Input, InputRef } from 'antd';
import { FormItem, useFormInstance } from 'components/Form';
import InputDOB from 'components/InputDOB';
import InputEmail from 'components/InputEmail';
import InputPhone from 'components/InputPhone';
import { ICustomerFormValues } from 'features/cashier/services/types/customer';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import ReferralInput from '../ReferralInput';
import cashierSelectors from 'features/cashier/services/selectors';
type IFormCustomerProps = {
  value?: ICustomerFormValues;
  inputRef?: React.RefObject<InputRef>;
};
const FormCustomer: React.FC<IFormCustomerProps> = ({ value, inputRef }) => {
  const enableReferral = cashierSelectors.enableReferral();
  const form = useFormInstance();
  useEffect(() => {
    form.setFieldsValue(value);
  }, [value]);


  return (
    <FormCustomerStyled className='FormAddCustomerStyled'>
      <FormItem name='name' label={'Full name'} rules={[{ required: true, message: 'Please input your name!' }]}>
        <Input ref={inputRef} />
      </FormItem>
      <FormItem name='phone' label={<>Phone<span className='required'>(*)</span></>} rules={[{ required: true, message: 'Please input your phone!' }]}>
        <InputPhone />
      </FormItem>
      <FormItem name='birthday' label={'DOB'}>
        <InputDOB inputReadOnly={false} />
      </FormItem>
      <InputEmail
        name={'email'} label="Email" rules={[{ type: 'email' }]}
      />
      {enableReferral && <FormItem
        name='phoneReferral'
        label={'Referrer’s Phone Number'}
        rules={[
          {
            validator: (_, value) => {
              if (!value) return Promise.resolve();
              const rawValue = value?.replace(/[^0-9]/g, '') || '';
              if (rawValue?.length < 10) return Promise.reject(new Error('Invalid phone number!'));
              return Promise.resolve();
            }
          }
        ]}
      >
        <InputPhone />
      </FormItem>}
    </FormCustomerStyled>
  );
};

export default FormCustomer;
type FormCustomerStyledProps = {}
const FormCustomerStyled = styled.div<FormCustomerStyledProps>`
  .required {
    color: var(--primary-primary-active, #FF8890);
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .input-email {
    height: 3rem
  }
`;
